import React from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import { setAuthData } from '../../actions/index';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { bindActionCreators } from 'redux';

class Logout extends React.Component {
    constructor(props) {
        super(props);

    }

    logoutHandle(authData) {                        
        // let data = {
        //     refresh_token:authData['refresh_token'],
        //     companyName:authData['companyName']
        // }           

        // const params = {
        //     auth: "system"
        // };

        // const url = "/app/authentication/logout";
        // CallAPI('POST', url, data, params, 0, function (response) {                
        //     location.href="/workspace";
        // });        
        localStorage.clear()
        location.href="/workspace";        
        logoutHandle();
    }

    render() {
        // this.logoutHandle(this.props.authData);
        logoutHandle('true');
        // return (<Redirect to="/workspace" />)
    }
}

function mapStateToProps(state) {    
    return { authData: state.dataSet.authData };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);